import * as React from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router";
import {Route, RouteProps as RoutePropsTypes} from "react-router-dom";
import {isLoggedIn, isDataRequested} from "../../modules/selectors";
import {IStoreState} from "../../modules/types";
import {OFF_SEASON_ENABLED} from "modules/utils";

interface IModelState {
	readonly is_authenticated?: boolean;
	readonly is_data_requested?: boolean;
}

type Props = RoutePropsTypes & IModelState;

const PrivateRouteComponent = ({
	is_authenticated,
	is_data_requested,
	location,
	...rest
}: Props) => {
	if (OFF_SEASON_ENABLED) {
		return <Redirect to="/" />;
	}

	return is_authenticated ? <Route {...rest} /> : <Redirect to="/" />;
};

const mapStateToProps = (state: IStoreState) => ({
	is_authenticated: isLoggedIn(state),
	is_data_requested: isDataRequested(state),
});

export const PrivateRoute = connect(mapStateToProps)(PrivateRouteComponent);
